import * as React from "react";

import { FullPageErrorModal } from "@editor/components/editor/page/FullPageErrorModal";
import EmptyLayout from "@editor/components/layouts/EmptyLayout";

const ShopifyInstalledOnNoAccessWorkspaceLayout = () => {
  return (
    <EmptyLayout>
      <FullPageErrorModal
        isClosable={false}
        details={{
          header: "Shopify Store Already Installed",
          subheader:
            "This Shopify store is already installed on another workspace that you do not have access to.",
          message:
            "In order to install this Shopify store on your workspace, get access from the workspace admin, or contact support@replo.app for help.",
          callToAction: {
            type: "navigate",
            location: { type: "home" },
          },
        }}
      />
    </EmptyLayout>
  );
};

export default ShopifyInstalledOnNoAccessWorkspaceLayout;
